import moment from "moment";
import Vue from "vue";
import router from "@/router";
import _ from "lodash";
import store from "@/store";
import TransactionService from "@/apiServices/TransactionService";
import CheckoutService from "@/apiServices/CheckoutService";
import PromosandOffersService from "@/apiServices/PromosandOffersService";
import { MAX_SEAT_LIMIT } from "@/config";
import MasterService from "@/apiServices/MasterService";
function initialState() {
  return {
    selectedSeats: [],
    seatType: null,
    movie: null,
    session: null,
    isMaxLimit: false,
    seatMaxLimit: 10,
    transactionID: null,
    reservationID: null,
    itemReservationID: null,
    orderID: null,
    rzpKeyId: null,
    curPrice: null,
    totalFnd: null,
    totalAmount: 0,
    internet_handling_charges: 0,
    gst: 0,
    gst_percent: 0,
    // curTax1: null,
    // curTax2: null,
    razorpay_payment_id: null,
    razorpay_order_id: null,
    razorpay_signature: null,
    promo_code: null,
    promo_amount: null,
    promo_success: false,
    bookingID: null,
    items: [],
    fndType: null,
    delivery_time: null,
    only_fnd_booking: null,
    fndSessionId: null,
    fndCinemaId: null,
    fndMovieId: null,
    fndSeats: null,
    fndUserSeat: null,
    fndUserSeatRow: null,
    user_booking_id: null,
    convenience_fee: {},
    bookingEndTime: null,
    promoApplied: false,
    isPriceChange: false,
    threeDCharge: 0,
  };
}

const state = initialState();

const mutations = {
  ON_SET_BOOKING_END_TIME: (state, payload) => {
    state.bookingEndTime = payload
  },
  ON_RESET_BOOKING_SUMMARY_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_MOVIE_AND_SESSION: (state, payload) => {
    const { movie, session } = payload;
    state.movie = movie;
    state.session = session;
  },
  SET_SEAT_TYPE: (state, payload) => {
    const { seatType } = payload;
    state.seatType = seatType;
  },
  ADD_TOTAL_AMOUNT: (state, payload) => {
    const { seatType } = payload;
    if (state.curPrice === null) {
      state.curPrice = seatType.Price_curPrice;
    } else {
      state.curPrice = state.curPrice + seatType.Price_curPrice;
    }
    state.totalAmount = state.totalAmount + seatType.Price_curPrice;
  },
  SUBTRACT_TOTAL_AMOUNT: (state, payload) => {
    const { seatType } = payload;
    if (state.selectedSeats.length === 0) {
      state.curPrice = null;
      // state.curTax1 = null;
      // state.curTax2 = null;
      state.totalAmount = 0;
    } else {
      state.curPrice = state.curPrice - seatType.Price_curPrice;
      state.totalAmount = state.totalAmount - seatType.Price_curPrice;
    }
  },
  REMOVE_SELECTED_SEAT: (state, payload) => {
    const { seatRow, seat, seatType } = payload;
    let FinalIndex = state.selectedSeats.findIndex(
      selectedSeat =>
        seatType.strAreaDesc === selectedSeat.seatType.strAreaDesc &&
        seatRow.strRowPhyID === selectedSeat.row.strRowPhyID &&
        seatRow.intGridRowID === selectedSeat.row.intGridRowID &&
        seat.strSeatNumber === selectedSeat.seat.strSeatNumber &&
        seat.strGridSeatNum === selectedSeat.seat.strGridSeatNum
    );
    state.selectedSeats.splice(FinalIndex, 1);
  },
  ADD_SELECTED_SEAT: (state, payload) => {
    const { seatRow, seat, seatType } = payload;
    seat.strSeatNumber = seat.strSeatNumber ? seat.strSeatNumber : seat.strGridSeatNum;
    state.selectedSeats.push({ row: seatRow, seat, seatType });
  },
  CLEAR_SEAT_SELECTION: (state, payload) => {
    state.selectedSeats = [];
    state.curPrice = null;
    // state.curTax1 = null;
    // state.curTax2 = null;
    state.promo_code = null;
    state.promo_amount = null;
    state.promo_success = false;
    state.totalAmount = 0;
    state.items = [];
  },
  SET_TRANSACTIONID: (state, payload) => {
    state.transactionID = payload;
  },
  SET_RESERVATION_ID: (state, payload) => {
    state.reservationID = payload;
  },
  SET_INT_BOOK_ID: (state, payload) => {
    state.intBookID = payload;
  },
  SET_ITEM_RESERVATION_ID: (state, payload) => {
    state.itemReservationID = payload;
  },
  SET_ORDER_ID: (state, payload) => {
    state.orderID = payload;
  },
  SET_RZP_KEY_ID: (state, payload) => {
    state.rzpKeyId = payload;
  },
  SET_BOOKING_ID: (state, payload) => {
    state.bookingID = payload;
  },
  SET_RAZORPAY_DETAILS: (state, payload) => {
    state.razorpay_payment_id = payload.razorpay_payment_id;
    state.razorpay_order_id = payload.razorpay_order_id;
    state.razorpay_signature = payload.razorpay_signature;
  },
  APPLY_PROMO: (state, payload) => {
    const { promo_code, promo_amount } = payload;
    if (promo_code && promo_amount) {
      state.promo_code = promo_code;
      state.promo_amount = promo_amount;
      state.totalAmount = state.totalAmount - state.promo_amount;
      state.promo_success = true;
    }
  },
  REMOVE_PROMO: (state, payload) => {
    state.totalAmount = state.totalAmount + state.promo_amount;
    state.promo_success = false;
    state.promo_code = null;
    state.promo_amount = null;
  },
  ADD_ITEM: (state, payload) => {
    payload.quantity = 1;
    state.items.push(payload);
    state.totalAmount = state.totalAmount + payload.Item_intPrice;
  },
  ADD_QUANTITY: (state, payload) => {
    state.items.map(item => {
      if (item.quantity < 9 && item.Item_strID === payload.Item_strID) {
        item.quantity = item.quantity + 1;
        state.totalAmount = state.totalAmount + payload.Item_intPrice;
      }
    });
  },
  REMOVE_ITEM: (state, payload) => {
    const index = state.items.findIndex(
      item => item.Item_strID === payload.Item_strID
    );
    state.items.splice(index, 1);
    state.totalAmount = state.totalAmount - payload.Item_intPrice;
  },
  REMOVE_QUANTITY: (state, payload) => {
    state.items.map(item =>
      item.Item_strID === payload.Item_strID
        ? (item.quantity = item.quantity - 1)
        : null
    );
    state.totalAmount = state.totalAmount - payload.Item_intPrice;
  },
  SET_FND_TYPE: (state, payload) => {
    state.fndType = payload;
  },
  SET_DELIVERY_TIME: (state, payload) => {
    state.delivery_time = payload;
  },
  ONLY_FND_BOOKING: (state, payload) => {
    state.only_fnd_booking = payload;
  },
  SET_FND_CINEMA_AND_SESSION: (state, payload) => {
    state.fndCinemaId = payload.Cinema_strID;
    state.fndSessionId = payload.Session_lngSessionId;
    state.fndMovieId = payload.Film_strCode;
    state.fndSeats = payload.strSeatInfo;
    state.session = payload.session || payload;
    state.movie = payload.session || payload;
  },
  SET_SEAT_AND_ROW: (state, payload) => {
    state.fndUserSeat = payload.seat;
    state.fndUserSeatRow = payload.row;
  },
  SET_USER_BOOKING_ID: (state, payload) => {
    state.user_booking_id = payload.booking_id;
  },
  ADD_INTERNET_HANDLING_CHARGES: (state, payload) => {
    // state.totalAmount -= state.internet_handling_charges;
    state.internet_handling_charges = payload;
    // state.totalAmount += state.internet_handling_charges;
  },
  ADD_GST: (state, payload) => {
    // state.totalAmount -= state.gst;
    state.gst_percent = payload / 100;
    state.gst = state.gst_percent * state.internet_handling_charges;
    // state.totalAmount += state.gst;
  },
  SET_CONVENIENCE_FEE: (state, payload) => {
    state.convenience_fee = payload;
  },
};

const actions = {
  async clearBookingSummaryStore({ dispatch, commit, state }, { ...payload }) {
    await commit("ON_RESET_BOOKING_SUMMARY_STORE_STATE");
  },
  async setMovieAndSession({ dispatch, commit, state }, { ...payload }) {
    await commit("SET_MOVIE_AND_SESSION", payload);
    await commit("CLEAR_SEAT_SELECTION");
  },
  async handleSeatSelection({ dispatch, commit, state }, { ...payload }) {
    const { seatRow, seat, $event } = payload;
    // console.log({ payload });
    if (seatRow && seat && seat.strSeatStatus === "0") {
      const isAlreadySelected = state.selectedSeats.some(
        selectedSeat =>
          selectedSeat.seat.strSeatNumber === seat.strSeatNumber &&
          selectedSeat.seat.strGridSeatNum === seat.strGridSeatNum &&
          selectedSeat.row.intGridRowID === seatRow.intGridRowID
      );
      if (isAlreadySelected) {
        await commit("REMOVE_SELECTED_SEAT", payload);
        await commit("SUBTRACT_TOTAL_AMOUNT", payload);
        $event.target.classList.remove("seat-selected", "selected-seat-m");
      } else {
        if (state.selectedSeats.length > 0) {
          if (state.selectedSeats[0].seatType === payload.seatType) {
            if (state.selectedSeats.length > MAX_SEAT_LIMIT - 1) {
              store.dispatch("AppSetting/showErrorNotification", {
                message: `Max limit of ${MAX_SEAT_LIMIT} seats reached`
              });
            } else {
              await $event.target.classList.add(
                "seat-selected",
                "selected-seat-m"
              );
              await commit("ADD_SELECTED_SEAT", payload);
              await commit("SET_SEAT_TYPE", payload);
              await commit("ADD_TOTAL_AMOUNT", payload);
            }
          } else {
            store.dispatch("AppSetting/showErrorNotification", {
              message: `Please select seats of the same type`
            });
          }
        } else {
          await $event.target.classList.add("seat-selected", "selected-seat-m");
          await commit("ADD_SELECTED_SEAT", payload);
          await commit("SET_SEAT_TYPE", payload);
          await commit("ADD_TOTAL_AMOUNT", payload);
        }
      }
    }
  },
  async setTransactionID({ dispatch, commit, state }, { ...payload }) {
    await commit("SET_TRANSACTIONID", payload.transaction_id);
  },
  async setRazorPayDetails({ dispatch, commit, state }, { ...payload }) {
    const razorpay = {
      razorpay_payment_id: payload.razorpay_payment_id,
      razorpay_order_id: payload.razorpay_order_id,
      razorpay_signature: payload.razorpay_signature
    };
    await commit("SET_RAZORPAY_DETAILS", razorpay);
  },
  async reserveSeats({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      if (state.selectedSeats.length > 0) {
        const getTransactionIDResponse = await TransactionService.GetTransactionID({ cinema_code: state.session.Cinema_strID });
        if (getTransactionIDResponse.data && getTransactionIDResponse.data.status) {
          await commit("SET_TRANSACTIONID", getTransactionIDResponse.data.data);

          const addSeatsResponse = await TransactionService.AddSeats({
            cinema_code: state.session.Cinema_strID,
            transaction_id: state.transactionID,
            session_id: state.session.Session_lngSessionId.toString(),
            type_code: state.seatType.TType_strCode,
            quantity: state.selectedSeats.length.toString()
          });



          if (addSeatsResponse.data && addSeatsResponse.data.status) {

            var localSeatPrice = state.seatType.Price_curPrice;
            var vistaSeatPrice = addSeatsResponse.data.data.curTotal / state.selectedSeats.length;

            state.isPriceChange = false;

            if (localSeatPrice != vistaSeatPrice) {
              state.isPriceChange = true;
              state.threeDCharge = (addSeatsResponse.data.data.curTotal / state.selectedSeats.length) - (addSeatsResponse.data.data.curTicketsTotal / state.selectedSeats.length)
              // console.log(state.threeDCharge);
              var result = confirm(`The price has been changed. Do you want to continue? The old price is ${localSeatPrice}, and the new price is ${vistaSeatPrice} per seat.`);

              if (!result) {
                return;
              }
              state.totalAmount = addSeatsResponse.data.data.curTotal;
              state.curPrice = addSeatsResponse.data.data.curTotal;
              state.seatType.Price_curPrice = vistaSeatPrice;
            }


            await commit("SET_INT_BOOK_ID", addSeatsResponse.data.data.intBookId);

            // const response = await fetch('https://api.ipify.org?format=json');
            // const data = await response.json();
            // const ip = data.ip;
            
            let ip = null;

            try {
              const response = await fetch('https://api.ipify.org?format=json');
              if (response.ok) {
                const data = await response.json();
                ip = data.ip;
              } else {
                console.error('Error fetching IP: Response not ok');
              }
            } catch (error) {
              console.error('Error fetching IP:', error);
            }

            const userAgent = navigator.userAgent;
            let source = ''
            if (/android/i.test(userAgent)) {
                source = 'Android Mobile';
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                source = 'iOS Mobile';
            } else if (/Windows/i.test(userAgent)) {
                source = 'Windows Desktop';
            } else if (/Macintosh/i.test(userAgent)) {
                source = 'Mac Desktop';
            } else if (/Linux/i.test(userAgent)) {
                source = 'Linux Desktop';
            } else if (/Mobile/i.test(userAgent)) {
                source = 'Mobile';
            } else {
                source = 'Unknown';
            }

            const setSeatsResponse = await TransactionService.SetSeats({
              cinema_code: state.session.Cinema_strID,
              session_id: state.session.Session_lngSessionId.toString(),
              transaction_id: state.transactionID,
              group_code: state.seatType.PGroup_strCode,
              type_code: state.seatType.TType_strCode,
              selectedSeats: state.selectedSeats,
              filmCode: state.movie.Film_strCode,
              quantity: state.selectedSeats.length.toString(),
              seatType: state.seatType,
              session_time: state.session.Session_dtmRealShow,
              isPriceChange: state.isPriceChange,
              threeDCharge: state.isPriceChange ? state.threeDCharge : 0,
              vistaSeatPrice,
              source: source,
              source_ip: ip,
            });

            if (setSeatsResponse.data && setSeatsResponse.data.status) {
              await commit("ON_SET_BOOKING_END_TIME", moment().add(7, "minutes").unix());
              // await commit("ON_SET_BOOKING_END_TIME", moment().add(10, "seconds").unix());
              await commit("SET_RESERVATION_ID", setSeatsResponse.data.data.reservation_id);
              await router.push({ path: "/fnd-checkout" });
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
    // TODO Hit reserve API with seat list,
    // Check if response is success
    // if true proceed to next page with reservation id,
    // else throw error and refresh page
    // if fnb flag active ? take to fnd checkout : summary
  },
  async completeBooking({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      if (state.only_fnd_booking) {
        const { razorpay_payment_id } = payload;
        const onlyFndCheckoutResponse = await CheckoutService.OnlyFndCheckout({
          items: state.items,
          cinema_code: state.fndCinemaId,
          movie_code: state.fndMovieId,
          fndType: state.fndType,
          delivery_time: state.delivery_time,
          session_id: state.fndSessionId,
          strSeatInfo: state.fndSeats,
          razorpay_payment_id,
          userSeat: state.fndUserSeat,
          userSeatRow: state.fndUserSeatRow,
          user_booking_id: state.user_booking_id,
          // internet_handling_charges: state.internet_handling_charges,
          // gst: state.gst
        });
        if (onlyFndCheckoutResponse.status) {
          await router.push({
            name: "Only Fnd Final Ticket",
            params: { transaction_id: onlyFndCheckoutResponse.data.data }
          });
          dispatch("clearBookingSummaryStore");
        }
      } else {
        // if (state.items.length > 0) {
        //   const addFndResponse = await TransactionService.AddFnd({
        //     reservation_id: state.reservationID,
        //     items: state.items,
        //     fndType: state.fndType,
        //     delivery_time: state.delivery_time
        //   });
        //   if (addFndResponse.data && addFndResponse.data.status) {
        //     await commit(
        //       "SET_ITEM_RESERVATION_ID",
        //       addFndResponse.data.data.item_reservation_id
        //     );
        //   }
        // }
        if (state.selectedSeats.length > 0) {
          const {
            razorpay_payment_id,
            promoApplied,
            promoAmount,
            promoPrefix
          } = payload;

          // console.log("BookingSummaryStore - completeBooking - payload", payload)
          const getPaymentStatusResponse = await CheckoutService.GetPaymentStatus(
            {
              reservation_id: state.reservationID,
              razorpay_payment_id,
              payment_type: 1,
              promoApplied,
              promoAmount,
              promoPrefix
            }
          );

          // console.log("payment status response ", getPaymentStatusResponse);

          if (getPaymentStatusResponse.status) {


            if (getPaymentStatusResponse.data.message != "BadTransaction") {
              await router.push({
                name: "Final Ticket",
                params: { transaction_id: getPaymentStatusResponse.data.data }
              });
              // this.clearBookingSummaryStore();
              dispatch("clearBookingSummaryStore");
            }
            else {
              window.location.reload();
            }

          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async setSeatAndRow({ dispatch, commit, state }, { ...payload }) {
    await commit("SET_SEAT_AND_ROW", payload);
  },
  async setUserBookingID({ dispatch, commit, state }, { ...payload }) {
    await commit("SET_USER_BOOKING_ID", payload);
  },
  async getRazorPayOrderID({ dispatch, commit, state }, { ...payload }) {
    try {
      const { 
        total_amount,
        payment_type,
        contact_user_name,
        contact_user_email,
        contact_user_mobile,
        mode
      } = payload;
      const { data } = await CheckoutService.GetRazorpayOrderId({
        reservation_id: state.reservationID,
        amount: total_amount,
        booking_type: state.only_fnd_booking ? "only_fnd" : "regular",
        payment_type,
        contact_user_name,
        contact_user_email,
        contact_user_mobile,
        mode
      });
      if (data && data.status) {
        await commit("SET_ORDER_ID", data.data.order_id);
        await commit("SET_RZP_KEY_ID", data.data.rzp_key_id);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async codCheckout({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      if (state.items.length > 0) {
        const addFndResponse = await TransactionService.AddFnd({
          reservation_id: state.reservationID,
          items: state.items,
          fndType: state.fndType,
          delivery_time: state.delivery_time
        });
        if (addFndResponse.data && addFndResponse.data.status) {
          await commit(
            "SET_ITEM_RESERVATION_ID",
            addFndResponse.data.data.item_reservation_id
          );
        }
      }
      if (state.selectedSeats.length > 0) {
        const {
          contact_user_name,
          contact_user_email,
          contact_user_mobile
        } = payload;
        const getPaymentStatusResponse = await CheckoutService.GetPaymentStatus(
          {
            reservation_id: state.reservationID,
            payment_type: 2,
            contact_user_name,
            contact_user_email,
            contact_user_mobile,
            internet_handling_charges: state.internet_handling_charges,
            gst: state.gst,
            total_amount: state.totalAmount
          }
        );
        if (getPaymentStatusResponse.status) {
          await router.push({
            name: "Final Ticket",
            params: { transaction_id: getPaymentStatusResponse.data.data }
          });
          // this.clearBookingSummaryStore();
          dispatch("clearBookingSummaryStore");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async bookNowPayLaterCheckout({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      if (state.items.length > 0) {
        const addFndResponse = await TransactionService.AddFnd({
          reservation_id: state.reservationID,
          items: state.items,
          fndType: state.fndType,
          delivery_time: state.delivery_time
        });
        if (addFndResponse.data && addFndResponse.data.status) {
          await commit(
            "SET_ITEM_RESERVATION_ID",
            addFndResponse.data.data.item_reservation_id
          );
        }
      }
      if (state.selectedSeats.length > 0) {
        const {
          contact_user_name,
          contact_user_email,
          contact_user_mobile
        } = payload;
        const getPaymentStatusResponse = await CheckoutService.GetPaymentStatus(
          {
            reservation_id: state.reservationID,
            payment_type: 3,
            contact_user_name,
            contact_user_email,
            contact_user_mobile,
            internet_handling_charges: state.internet_handling_charges,
            gst: state.gst,
            total_amount: state.totalAmount
          }
        );
        if (getPaymentStatusResponse.status) {
          await router.push({
            name: "Final Ticket",
            params: { transaction_id: getPaymentStatusResponse.data.data }
          });
          // this.clearBookingSummaryStore();
          dispatch("clearBookingSummaryStore");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async groupBookingCheckout({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    const { razorpay_payment_id } = payload;
    try {
      if (state.items.length > 0) {
        const addFndResponse = await TransactionService.AddFnd({
          reservation_id: state.reservationID,
          items: state.items,
          fndType: state.fndType,
          delivery_time: state.delivery_time
        });
        if (addFndResponse.data && addFndResponse.data.status) {
          await commit(
            "SET_ITEM_RESERVATION_ID",
            addFndResponse.data.data.item_reservation_id
          );
        }
      }
      if (state.selectedSeats.length > 0) {
        const getPaymentStatusResponse = await CheckoutService.GetPaymentStatus(
          {
            reservation_id: state.reservationID,
            payment_type: 4,
            friends: payload.friends,
            razorpay_payment_id,
            seatType: state.seatType,
            // internet_handling_charges: state.internet_handling_charges,
            // gst: state.gst
          }
        );
        if (getPaymentStatusResponse.status) {
          await router.push({
            name: "Final Ticket",
            params: { transaction_id: getPaymentStatusResponse.data.data }
          });
          // this.clearBookingSummaryStore();
          dispatch("clearBookingSummaryStore");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async completePayLaterTransaction(
    { dispatch, commit, state },
    { ...payload }
  ) {
    let loader = Vue.$loading.show();
    try {
      const { transaction_id, razorpay_payment_id } = payload;
      const getPaymentStatusResponse = await TransactionService.CompletePayLaterTransaction(
        {
          transaction_id,
          razorpay_payment_id
        }
      );
      if (getPaymentStatusResponse.status) {
        await router.push({
          name: "Final Ticket",
          params: { transaction_id: getPaymentStatusResponse.data.data }
        });
        // this.clearBookingSummaryStore();
        dispatch("clearBookingSummaryStore");
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async makePayment({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      if (state.selectedSeats.length > 0) {
        await router.push({ path: "/regularBooking" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  // async bookSeats({ dispatch, commit, state }, { ...payload }) {
  //   let loader = Vue.$loading.show();
  //   try {
  //     if (state.selectedSeats.length > 0) {
  //       const createOrder = await CheckoutService.GetRazorpayDetails({
  //         reservation_id: state.reservationID
  //       });

  //       if (createOrder.data && createOrder.data.status) {
  //         await commit("SET_ORDER_ID", createOrder.data.data);
  //         const bookSeatsResponse = await TransactionService.BookSeats({
  //           cinema_code: state.session.Cinema_strID,
  //           session_id: state.session.Session_lngSessionId.toString(),
  //           transaction_id: state.transactionID,
  //           selectedSeats: state.selectedSeats,
  //           quantity: state.selectedSeats.length.toString(),
  //           type_code: state.seatType.TType_strCode
  //         });
  //         if (bookSeatsResponse.data && bookSeatsResponse.data.status) {
  //           await commit("SET_BOOKING_ID", bookSeatsResponse.data.strBookIdEx);
  //           const bookStatusResponse = await TransactionService.BookStatus({
  //             cinema_code: state.session.Cinema_strID,
  //             booking_id: state.bookingID
  //           });
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     loader.hide();
  //   }
  // },
  async cancelTransaction({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    const { refresh } = payload;
    try {
      if (state.transactionID) {
        // temp
        // router.push({ path: "/" });
        //
        const response = await CheckoutService.CancelTransaction({
          transaction_id: state.transactionID,
          cinema_code: state.session.Cinema_strID
        });
        const { data } = response;
        if (data && data.status) {

          if (store.state.promoApplied) {
            const PromoResponse = await PromosandOffersService.RemovePromo({ TransactionID: state.transactionID });
            let jsonResponse = PromoResponse.data.data
            if (jsonResponse.status === "true") {
              store.state.promoApplied = false;
              sessionStorage.removeItem("PromoDetails");
            } else {
              store.state.promoApplied = true;
            }
          }
          await commit("ON_RESET_BOOKING_SUMMARY_STORE_STATE");
          if (refresh) {
            await router.push({ path: "/" });
          }
        }
      } else {
        await router.push({ path: "/" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async getInternetHandlingCharges(
    { dispatch, commit, state },
    { ...payload }
  ) {
    try {
      const { data } = await CheckoutService.GetCharges({
        amount: state.totalAmount,
        cinema_code: state.session.Cinema_strID
      });
      if (data && data.status) {
        await commit("ADD_INTERNET_HANDLING_CHARGES", data.data.charge);
        await commit("ADD_GST", parseInt(data.data.gst_percent));
      }
    } catch (error) {
      console.error(error);
    }
  },
  async verifyPromo({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    try {
      const { promo_code } = payload;
      await commit("REMOVE_PROMO");
      if (state.selectedSeats.length > 0) {
        const response = await PromosandOffersService.VerifyPromo({
          promo_code,
          movie_code: state.movie.Film_strCode
        });
        const { data } = response;
        if (data && data.status) {
          await commit("REMOVE_PROMO");
          await commit("APPLY_PROMO", data.data);
        } else {
          store.dispatch("AppSetting/showErrorNotification", {
            message: "Invalid promo code"
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.hide();
    }
  },
  async removePromoCode({ dispatch, commit, state }, { ...payload }) {
    let loader = Vue.$loading.show();
    await commit("REMOVE_PROMO");
    loader.hide();
  },
  async addItem({ dispatch, commit, state }, { ...payload }) {
    const { Item_strID } = payload;
    if (state.items.length === 0) {
      await commit("ADD_ITEM", payload);
    } else {
      const existingItem = state.items.find(
        item => item.Item_strID === Item_strID
      );
      if (existingItem) {
        await commit("ADD_QUANTITY", payload);
      } else {
        await commit("ADD_ITEM", payload);
      }
    }
  },
  async removeItem({ dispatch, commit, state }, { ...payload }) {
    const { Item_strID } = payload;
    const existingItem = state.items.find(
      item => item.Item_strID === Item_strID
    );
    if (existingItem.quantity === 1) {
      await commit("REMOVE_ITEM", existingItem);
    } else {
      await commit("REMOVE_QUANTITY", existingItem);
    }
  },
  async setfndType({ dispatch, commit, state }, { ...payload }) {
    const { delivery_type, delivery_time, direct } = payload;

    await commit("SET_FND_TYPE", delivery_type);

    await commit("SET_DELIVERY_TIME", delivery_time);
    if (direct) {
      await commit("ONLY_FND_BOOKING", true);
      // dispatch("onHandleOpenModal", "verifyBookingModal");
    } else {
      await router.push({ path: "/regularBooking" });
    }
  },
  async setFndCinemaAndSession({ dispatch, commit, state }, { ...payload }) {
    await commit("SET_FND_CINEMA_AND_SESSION", payload);
  },
  async setConvenienceFees({ dispatch, commit, state }, { ...payload }) {
    try {
      let {ShowConvenience} = payload;
      if(ShowConvenience == true){
        let response = await MasterService.GetConvenienceFee({
          Cinema_strID: state.session.Cinema_strID,
          Transaction_ID: state.transactionID
        });
        await commit("SET_CONVENIENCE_FEE", response.data.data);
      }else{
        await commit("SET_CONVENIENCE_FEE", {});
      }
    } catch (error) {
      await commit("SET_CONVENIENCE_FEE", {});
    }
  },
  async setItemDetails({ dispatch, commit, state }, { ...payload }) {
    try {
      if (state.items.length > 0) {
        const addFndResponse = await TransactionService.AddFnd({
          reservation_id: state.reservationID,
          items: state.items,
          fndType: state.fndType,
          delivery_time: state.delivery_time
        });
        if (addFndResponse.data && addFndResponse.data.status) {
          await commit(
            "SET_ITEM_RESERVATION_ID",
            addFndResponse.data.data.item_reservation_id
          );
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
};

const getters = {
  getBookingEndTime: state => state.bookingEndTime,
  getSelectedSeats: state => state.selectedSeats,
  getBookingSummaryMovie: state => state.movie,
  getBookingSummarySession: state => state.session,
  getTotalAmount: state => state.totalAmount,
  getCurPrice: state => state.curPrice,
  // getCurTax1: state => state.curTax1,
  // getCurTax2: state => state.curTax2,
  getOrderID: state => state.orderID,
  getRzpKeyId: state => state.rzpKeyId,
  getTransactionID: state => state.transactionID,
  getReservationID: state => state.reservationID,
  getIntBookID: state => state.intBookID,
  getPromoSuccess: state => state.promo_success,
  getPromoCode: state => state.promo_code,
  getPromoAmount: state => state.promo_amount,
  getStoreItems: state => state.items,
  getCinema: state => state.seatType.Cinema_strID,
  getAreaCategoryCode: state => state.seatType.AreaCat_strCode,
  getOnlyFndBooking: state => state.only_fnd_booking,
  getPrice_curPrice: state => state.seatType.Price_curPrice,
  getInternet_handling_charges: state => state.internet_handling_charges,
  getGST: state => state.gst,
  getGSTPercent: state => state.gst_percent,
  getConvenienceFee: state => state.convenience_fee
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/BookingSummaryStore.js